import { logger } from './LoggerHelper';
import {envConfig} from '../configuration/Configuration';

export enum ReportedUiState
{
    Phase1,
    Phase2
}

class UiPhaseReporter {

    getDocHeight = () => {
        var doc = document;
        var body = doc.body, html = doc.documentElement;
        var height = Math.max( body.scrollHeight, body.offsetHeight, 
            html.clientHeight, html.scrollHeight, html.offsetHeight );
        return height;
    }

    public report() {
        if (window && window.parent) {
            const height = this.getDocHeight();
            logger.Log('Posting phase and height: ' + height);
            window.parent.postMessage(height, envConfig.ParentOrigin);
        }
    }
}

export const resizeReporter = new UiPhaseReporter();